import { Trans } from '@lingui/react';
import { Modal } from '@startuptools/ui/Modal';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { type ComponentProps } from 'react';
import { TodoForm } from './TodoForm';

export const AddTodoDialog = ({
  onClose,
  ...formProps
}: { onClose: () => void } & Omit<ComponentProps<typeof TodoForm>, 'onCancel'>) => {
  return (
    <Modal open onClose={(_, reason) => reason === 'closeClick' && onClose()}>
      <ModalDialog minWidth={600}>
        <ModalClose />
        <Stack marginY={3} gap={2}>
          <Typography level="h4">
            <Trans id="Create Todo" />
          </Typography>
          <TodoForm {...formProps} onCancel={onClose} />
        </Stack>
      </ModalDialog>
    </Modal>
  );
};
